import { assertNonNullable } from '@examdojo/util/assert';
import { isNullish } from '@examdojo/util/nullish';
import { LanguageCode } from './language';

export type LocalizedString = Partial<Record<LanguageCode, string>>;

export function extractFromLocalizedString(value: unknown): string {
  if (isNullish(value)) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    const englishValue = (value as LocalizedString)['en'];
    assertNonNullable(englishValue, 'englishValue');
    return englishValue;
  }

  throw new Error(`Could not extract localized string from ${value?.toString()}`);
}
